import {Injectable} from '@angular/core';
import {map, take} from 'rxjs/operators';
import {UserService} from '../_services/user.service';
import {CanActivate, Router} from '@angular/router';
import {Observable,combineLatest} from 'rxjs';
import {UserType} from '../_models/user';

@Injectable()
export class GuestGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService
  ) {}

  canActivate(): Observable<boolean> {
    return combineLatest([
      this.userService.isAuthenticated,
      this.userService.currentUser
    ]).pipe(
      take(1),
      map(([isAuth, currentUser]) => {
        if (!isAuth) {
          this.router.navigate(['/guest/login']);
          return false;
        }

        if (currentUser.userType !== UserType.Unregistered) {
          this.router.navigate(['/app/dashboard']);
          return false;
        }

        return true;
      })
    );
  }
}
